// extracted by mini-css-extract-plugin
module.exports = {"card":"NotFound_card__AW1T-"};